export type Language = "cs" | "sk" | "hu" | "pl" | "en";
export type Country = "cz" | "sk" | "hu" | "pl" | "us";

export type UsaState =
  | "AL" // Alabama
  | "AK" // Alaska
  | "AZ" // Arizona
  | "AR" // Arkansas
  | "CA" // California
  | "CO" // Colorado
  | "CT" // Connecticut
  | "DE" // Delaware
  | "FL" // Florida
  | "GA" // Georgia
  | "HI" // Hawaii
  | "ID" // Idaho
  | "IL" // Illinois
  | "IN" // Indiana
  | "IA" // Iowa
  | "KS" // Kansas
  | "KY" // Kentucky
  | "LA" // Louisiana
  | "ME" // Maine
  | "MD" // Maryland
  | "MA" // Massachusetts
  | "MI" // Michigan
  | "MN" // Minnesota
  | "MS" // Mississippi
  | "MO" // Missouri
  | "MT" // Montana
  | "NE" // Nebraska
  | "NV" // Nevada
  | "NH" // New Hampshire
  | "NJ" // New Jersey
  | "NM" // New Mexico
  | "NY" // New York
  | "NC" // North Carolina
  | "ND" // North Dakota
  | "OH" // Ohio
  | "OK" // Oklahoma
  | "OR" // Oregon
  | "PA" // Pennsylvania
  | "RI" // Rhode Island
  | "SC" // South Carolina
  | "SD" // South Dakota
  | "TN" // Tennessee
  | "TX" // Texas
  | "UT" // Utah
  | "VT" // Vermont
  | "VA" // Virginia
  | "WA" // Washington
  | "WV" // West Virginia
  | "WI" // Wisconsin
  | "WY"; // Wyoming

export interface WebsiteDto {
  id: string;
  createdAt: Date;
  lastModifiedAt: Date;
  name: string;
  url: string;
  language: Language;
  campaignCount: number;

  //#region logo settings

  logo?: string;
  logoDisplay: boolean;
  logoBackgroundColor?: string;
  logoText?: string;

  //#endregion

  //#region zbozi settings

  zboziName?: string;
  zboziApiKey?: string;
  zboziId?: string;

  //#endregion

  //#region heureka settings

  heurekaName?: string;
  heurekaApiKey?: string;
  heurekaCountry?: Country;

  //#endregion

  spolehlivaRecenzeShopId?: string;
  spolehlivaRecenzeShopPassword?: string;

  //#region google reviews settings

  googleReviewsPlacesQuery?: string;
  googleReviewsPlaceId?: string;
  googleReviewsBusinessName?: string;

  //#endregion

  //#region trustpilot settings

  trustpilotBusinessUnitId?: string;

  //#endregion
}

export const getLanguageFromString = (language: string): Language => {
  switch (language) {
    case "cs":
      return "cs";
    case "sk":
      return "sk";
    case "hu":
      return "hu";
    case "pl":
      return "pl";
    default:
      return "cs";
  }
};
